import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeStrongNoAttributesCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const exclude = watch('exclude_strong_no_attributes');

  return (
    <Checkbox
      data-provides={'talent-matching-exclude-strong-no-attribute-checkbox'}
      checked={exclude}
      onChange={(checked) =>
        setValue('exclude_strong_no_attributes', checked, { shouldDirty: true })
      }
      label={t('strong_no_attribute')}
      value={'exclude_strong_no_attributes'}
    />
  );
};

export default ExcludeStrongNoAttributesCheckbox;
